import React from 'react';
import NavBar2 from '../Components/NavBar2';

function TermsOfUse() {
  return (
    <div>

    <NavBar2/>

    <div className="container px-4 py-5 mt-5">
      
      <h1 className="mb-4">Terms of Use & Privacy Policy</h1>

      <p><strong>Last updated:</strong> June 9, 2025</p>

      <h2>1. Introduction</h2>
      <p>Welcome to Kuza Points, a product developed and managed by Ubunifu Lab, the AI research and development center of Ubunifu College. By accessing or using Kuza Points (“Platform”, "Service", “we”, “our” or “us”), you agree to be bound by these Terms of Use and our Privacy Policy.</p>

      <h2>2. Acceptance of Terms</h2>
      <p>By signing up or accessing Kuza Points, you agree to be legally bound by these terms. If you do not agree with any part of the terms, you must not use the platform.</p>

      <h2>3. Eligibility</h2>
      <p>You must be at least 18 years old to use Kuza Points. By using this service, you represent and warrant that you meet the above eligibility requirement.</p>

      <h2>4. Use of Service</h2>
      <ul>
        <li>You agree not to misuse the platform for illegal purposes.</li>
        <li>You are responsible for all content entered into your business account.</li>
        <li>You agree not to attempt to breach or hack the platform's systems.</li>
      </ul>

      <h2>5. User Accounts</h2>
      <p>You are responsible for maintaining the confidentiality of your account credentials. Kuza Points will not be liable for any loss or damage arising from unauthorized use of your account.</p>

      <h2>6. Loyalty and SMS Services</h2>
      <p>Businesses using Kuza Points can issue points, send SMS notifications, and initiate redemptions. You acknowledge that SMS services are subject to third-party delivery and carrier reliability.</p>

      <h2>7. Data Protection & Privacy Policy</h2>
      <p>We are committed to protecting your privacy and complying with Kenya's Data Protection Act, 2019.</p>

      <h3>7.1 Personal Data Collection</h3>
      <p>We collect personal data including names, phone numbers, business identifiers, and usage logs strictly for service provision, user support, and security purposes.</p>

      <h3>7.2 Purpose of Collection</h3>
      <ul>
        <li>To provide and manage the Kuza Points platform</li>
        <li>To communicate service-related updates via SMS or email</li>
        <li>To improve customer experience and troubleshoot issues</li>
      </ul>

      <h3>7.3 Data Sharing</h3>
      <p>We do not sell or rent user data to third parties. However, we may share data with trusted service providers strictly for operational purposes (e.g. SMS gateways).</p>

      <h3>7.4 Data Retention</h3>
      <p>We retain data only for as long as necessary to provide our services and as required by law.</p>

      <h3>7.5 Data Security</h3>
      <p>We implement physical, electronic, and managerial safeguards to secure your information.</p>

      <h3>7.6 Your Rights</h3>
      <p>Under the Data Protection Act of Kenya, you have the right to:</p>
      <ul>
        <li>Access your personal data</li>
        <li>Request correction or deletion of your data</li>
        <li>Withdraw consent at any time</li>
        <li>File a complaint with the Office of the Data Protection Commissioner (ODPC)</li>
      </ul>

      <h2>8. Intellectual Property</h2>
      <p>All platform content, features, and branding remain the intellectual property of Ubunifu College and its developers. You may not reuse or reproduce any part without permission.</p>

      <h2>9. Limitation of Liability</h2>
      <p>Kuza Points shall not be liable for any indirect, incidental, or consequential damages arising out of your use of the platform.</p>

      <h2>10. Termination</h2>
      <p>We reserve the right to suspend or terminate your access to the service at our discretion, especially in cases of misuse or breach of terms.</p>

      <h2>11. Amendments</h2>
      <p>We may update these Terms of Use or Privacy Policy from time to time. Changes will be posted on this page with an updated revision date.</p>

      <h2>12. Contact Us</h2>
      <p>If you have questions or concerns about these Terms or the Privacy Policy, you can contact us at:</p>
      <p><strong>Email:</strong> hello["@"]kuzapoints.com</p>
      <p><strong>Office:</strong> Paramount Plaza, 4th Floor</p>
    </div>
    </div>

  );
}

export default TermsOfUse;